import {
  createFileRoute,
  redirect,
  SearchParamError,
} from "@tanstack/react-router";

import { resetPasswordSearchSchema } from "@/modules/reset-password/schemas/resetPasswordSearchSchema";
import { ResetPasswordScreen } from "@/modules/reset-password/screens/ResetPassword";

export const Route = createFileRoute("/reset-password")({
  validateSearch: resetPasswordSearchSchema,
  onError: (error) => {
    if (error instanceof SearchParamError) {
      throw redirect({ to: "/not-found" });
    }
  },
  component: ResetPasswordScreen,
});
